<div class='BlockDates'>
  <div class='Breadcrumbs'>
    <div class='Breadcrumbs-items'>
      <a [routerLink]="['/campaigns']"
      >
        <mat-icon class='Breadcrumbs-icon back'
        >keyboard_backspace
        </mat-icon
        >
      </a
      >
      <a [routerLink]="['/campaigns']" class='Breadcrumbs-item first'
      >Campaigns</a
      >
      <mat-icon class='Breadcrumbs-icon'>chevron_right</mat-icon>
      <span class='Breadcrumbs-item'>Campaign Block Dates</span>
    </div>
  </div>
  <div class='BlockDates__container pt-5'>
    <div class='picker'>
      <form [formGroup]='formGroup' class='d-flex flex-row'>
        <mat-label>Block Date</mat-label>
        <app-text-field
          [datePickerType]="'calendar'"
          formControlName='date'
          type='date'></app-text-field>
        <app-button
          (click)='submit()'
          [color]="'orange'"
          [disabled]='submitDisabled'
          [size]="'normal'"
          [text]="'Submit'"
          class='ms-3'></app-button>
      </form>
    </div>
    <div class='DatesListing-block mt-5'>
      <div class='DatesListing-block-body'>
        <div class='SimpleTable'>
          <div class='SimpleTable__header'>
            <div class='SimpleTable__header__item'>
              <span class='SimpleTable__header__item__text'
              >Date (MM/DD/YY)</span
              >
            </div>
            <div class='SimpleTable__header__item'>
              <span class='SimpleTable__header__item__text'>Remove</span>
            </div>
          </div>
          <div class='SimpleTable__body'>
            <div
              *ngFor='let item of dates | keyvalue: originalOrder'
              class='SimpleTable__body__row'>
              <div class='SimpleTable__body__row__cell'>
                <h5>
                  {{
                    item.value | timezone: 'MM/DD/YY' : sessionData.time_zone
                  }}
                </h5>
              </div>
              <div class='SimpleTable__body__row__cell'>
                <app-button
                  (click)='delete(item.key)'
                  *ngIf='systemDates.indexOf(item.value) === -1; else systemBlockDate'
                  [color]='deleteDateButton.color'
                  [observeApi]="true"
                  [size]='deleteDateButton.size'
                  [style]='deleteDateButton.style'
                  [text]='deleteDateButton.text'
                  class='DatesListing-block-body-list-item-button'></app-button>
              </div>
              <ng-template #systemBlockDate>
                <p>System Block Date</p>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
